module.exports = __webpack_public_path__ + "media/images/loading-5f9ee6a13fbe667dd6c58e0c06f3130c.gif";